import React, { useState, useEffect } from "react";
import PageLayout from "../../Layouts/PageLayout/PageLayout";
import Table from "../../components/common/Table/Table";
import { getApiInstance } from "../../utils/api";
import { useZone } from "../../context/ZoneContext";
import { useTranslation } from "react-i18next";
import { FiDownload } from "react-icons/fi";
import { IoMdAdd } from "react-icons/io";
import Modal from "../../components/common/Modal/Modal";
import FormModal from "../../components/common/FormModal/FormModal";
import { mapList } from "../../utils/utils";
import FiltersDrawer from "../../components/common/FiltersDrawer/FiltersDrawer";
import Pagination from "../../components/common/Pagination/Pagination";
import { useRef } from "react";
import Notification from "../../components/common/notification/notification";
import Button from "../../components/common/Button/Button";
import InputSearch from "../../components/common/Inputs/InputSearch/InputSearch";
import { useMemo } from "react";
import ResiduoCard from "../../components/common/ResiduoCard/ResiduoCard";
import { MdFilterList } from "react-icons/md";
import "./Residuos.scss";
import { getConfig } from "../../utils/config";

//   const formElements = [
//     {
//       elements: [
//         {
//           name: "codigo",
//           type: "text",
//           label: t('waste.form.code'),
//           placeholder: t('waste.form.codePlaceholder'),
//           required: true,
//           disabled: false,
//           labelVisible: true,
//           visible: true,
//         },
//         {
//           name: "nombre",
//           type: "text",
//           label: t('waste.form.name'),
//           placeholder: t('waste.form.namePlaceholder'),
//           required: true,
//           disabled: false,
//           labelVisible: true,
//           visible: true,
//         },
//         {
//           name: "descripcion",
//           type: "textarea",
//           label: t('waste.form.description'),
//           placeholder: t('waste.form.descriptionPlaceholder'),
//           required: false,
//           disabled: false,
//           labelVisible: true,
//           visible: true,
//         },
//         {
//           name: "tipo",
//           type: "select",
//           label: t('waste.form.type'),
//           placeholder: t('waste.form.typePlaceholder'),
//           required: true,
//           disabled: false,
//           labelVisible: true,
//           visible: true,
//           options: [
//             { value: "peligroso", label: t('waste.wasteDangerous') },
//             { value: "no_peligroso", label: t('waste.wasteNoDangerous')  },
//           ],
//         },
//       ],
//     },
//   ];

export default function Residuos({ user }) {
    const { t } = useTranslation();
    const [residuos, setResiduos] = useState([]);
    const [filteredResiduos, setFilteredResiduos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { selectedZone } = useZone();
    const [residuosTipo, setResiduosTipo] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
    const [filterValues, setFilterValues] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalData, setModalData] = useState({});
    const [modalType, setModalType] = useState("add");
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const [residuoToDelete, setResiduoToDelete] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(12); // 12 cards por página

    const config = getConfig();
    const isMabe = config?.REACT_APP_IS_MABE === "true";

    const filterFields = [
        { key: "nombre", label: t("fields.name"), type: "text" },
        {
            key: "tipoResiduo",
            label: t("waste.columns.type"),
            type: "multiselect",
            objectProp: "descripcion",
        },
    ];

    const notificationRef = useRef(null);

    const formElements = [
        {
            elements: [
                {
                    name: "codigo",
                    type: "text",
                    label: "Código Ler",
                    placeholder: "Ingrese el código ler",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "nombre",
                    type: "text",
                    label: "Nombre",
                    placeholder: "Ingrese el nombre del residuo",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "codTipoResiduo",
                    type: "select",
                    label: "Tipo de residuo",
                    placeholder: "Seleccione el tipo de residuo",
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    options: residuosTipo,
                },
                ...(isMabe
                    ? [
                          {
                              name: "codCaracteristicaPeligrosidad",
                              type: "multiselect",
                              label: "Característica de peligrosidad",
                              placeholder:
                                  "Seleccione la característica de peligrosidad",
                              required: false,
                              disabled: false,
                              labelVisible: true,
                              visible: true,
                              options: [
                                  { value: "1", label: "C - Corrosivo" },
                                  { value: "2", label: "R - Reactivo" },
                                  { value: "3", label: "E - Explosivo" },
                                  { value: "4", label: "T - Tóxico" },
                                  {
                                      value: "5",
                                      label: "Te - Toxicidad Ambiental",
                                  },
                                  { value: "6", label: "Th - Toxicidad Aguda" },
                                  {
                                      value: "7",
                                      label: "Tt - Toxicidad Crónica",
                                  },
                                  { value: "8", label: "I - Inflamable" },
                                  {
                                      value: "9",
                                      label: "B - Biológico Infeccioso",
                                  },
                                  {
                                      value: "10",
                                      label: "M - Mezcla de Residuos",
                                  },
                              ],
                          },
                      ]
                    : []),
                ...(isMabe
                    ? [
                          {
                              name: "codAreaGeneracion",
                              type: "multiselect",
                              label: "Área o proceso de generación",
                              placeholder:
                                  "Seleccione el área o proceso de generación",
                              required: false,
                              disabled: false,
                              labelVisible: true,
                              visible: true,
                              options: [
                                  { value: "1", label: "Servicio Médico" },
                                  {
                                      value: "2",
                                      label: "Fabricación/Serigrafía",
                                  },
                                  { value: "3", label: "Ensamble" },
                                  { value: "4", label: "Esmalte" },
                              ],
                          },
                      ]
                    : []),
                {
                    name: "descripcion",
                    type: "textarea",
                    label: "Descripción",
                    placeholder:
                        "Ingrese una descripción detallada del residuo",
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "codZona",
                    type: "hidden",
                    label: "Zona",
                    placeholder: "",
                    required: true,
                    disabled: false,
                    labelVisible: false,
                    visible: false,
                    defaultValue: selectedZone.value,
                },
            ],
        },
    ];

    const fetchResiduos = async () => {
        setLoading(true);
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/Residuos/GetResiduosByZona?codZona=${selectedZone.value}`
            );
            setResiduos(response.data);
            setFilteredResiduos(response.data);
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar los residuos. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchResiduosTipo = async () => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/ResiduosTipo/GetResiduosTipoByZona/${selectedZone.value}`
            );
            setResiduosTipo([
                ...mapList(response.data, "descripcion", "codTipoResiduo"),
            ]);
            setError(null);
        } catch (err) {
            setError("No se han podido cargar los tipos de residuo.");
            console.error(err);
        }
    };

    useEffect(() => {
        fetchResiduos();
        fetchResiduosTipo();
    }, [selectedZone]);

    // Filtrado y búsqueda
    useEffect(() => {
        let filtered = residuos;

        if (searchTerm) {
            filtered = filtered.filter(
                (r) =>
                    r.nombre
                        ?.toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                    r.codigo
                        ?.toLowerCase()
                        .includes(searchTerm.toLowerCase()) ||
                    r.tipoResiduo?.descripcion
                        ?.toLowerCase()
                        .includes(searchTerm.toLowerCase())
            );
        }

        Object.entries(filterValues).forEach(([key, val]) => {
            if (!val || (Array.isArray(val) && val.length === 0)) return;

            if (key === "nombre") {
                filtered = filtered.filter((r) =>
                    r.nombre?.toLowerCase().includes(val.toLowerCase())
                );
            }
            if (key === "tipoResiduo" && Array.isArray(val)) {
                filtered = filtered.filter((r) =>
                    val.some(
                        (v) =>
                            v.value === r.tipoResiduo?.descripcion ||
                            v === r.tipoResiduo?.descripcion
                    )
                );
            }
        });

        setFilteredResiduos(filtered);
        setCurrentPage(1);
    }, [searchTerm, filterValues, residuos]);

    const paginatedResiduos = useMemo(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        return filteredResiduos.slice(startIndex, endIndex);
    }, [filteredResiduos, currentPage, itemsPerPage]);

    const totalPages = Math.ceil(filteredResiduos.length / itemsPerPage);

    const handleEdit = (residuo) => {
        setModalData(residuo);
        setModalType("edit");
        setIsModalOpen(true);
    };

    const handleDelete = (residuo) => {
        setResiduoToDelete(residuo);
        setConfirmationModalOpen(true);
    };

    const confirmDelete = async () => {
        if (!residuoToDelete) return;

        try {
            const api = getApiInstance();
            await api.delete(
                `/api/Residuos/DeleteResiduo/${residuoToDelete.codResiduo}`
            );

            notificationRef.current?.addNotification(
                "Residuo eliminado correctamente",
                "success"
            );

            setConfirmationModalOpen(false);
            setResiduoToDelete(null);

            setResiduos((prev) =>
                prev.filter((r) => r.codResiduo !== residuoToDelete.codResiduo)
            );
            setFilteredResiduos((prev) =>
                prev.filter((r) => r.codResiduo !== residuoToDelete.codResiduo)
            );
        } catch (err) {
            console.error("Error al eliminar:", err);
            notificationRef.current?.addNotification(
                "Error al eliminar el residuo",
                "error"
            );
            setConfirmationModalOpen(false);
            setResiduoToDelete(null);
        }
    };

    const handleSave = async () => {
        try {
            const api = getApiInstance();
            const payload = {
                ...modalData,
                codTipoResiduo:
                    typeof modalData.codTipoResiduo === "object"
                        ? modalData.codTipoResiduo.value
                        : modalData.codTipoResiduo,
                codZona: selectedZone.value,
            };

            if (modalType === "edit") {
                await api.put(
                    `/api/Residuos/EditResiduo/${payload.codResiduo}`,
                    payload
                );
                notificationRef.current?.addNotification(
                    "Residuo actualizado correctamente",
                    "success"
                );
            } else {
                await api.post("/api/Residuos/SetResiduo", payload);
                notificationRef.current?.addNotification(
                    "Residuo creado correctamente",
                    "success"
                );
            }

            setIsModalOpen(false);
            setModalData({});
            fetchResiduos();
        } catch (err) {
            console.error("Error al guardar:", err);
            notificationRef.current?.addNotification(
                "Error al guardar el residuo",
                "error"
            );
        }
    };

    // return (
    //     <PageLayout
    //         title="Residuos"
    //         subtitle="Aquí verás todos los residuos de tu organización"
    //         // actions={[
    //         //     <Button
    //         //         key="export"
    //         //         componentType="link"
    //         //         variant="outlined"
    //         //         href="/"
    //         //         startIcon={<FiDownload />}
    //         //     >
    //         //         Exportar Excel
    //         //     </Button>,
    //         // ]}
    //     >
    //         <div className="residuos-container">
    //             <div className="residuos-container__toolbar">
    //                 <div style={{ flex: 1, maxWidth: "400px" }}>
    //                     <InputSearch
    //                         placeholder={t("waste.searchPlaceholder")}
    //                         onSearch={setSearchTerm}
    //                     />
    //                 </div>
    //                 <div className="residuos-container__actions">
    //                     <Button
    //                         variant="ghost"
    //                         startIcon={MdFilterList({})}
    //                         onClick={() => setIsFilterModalOpen(true)}
    //                         endIcon={undefined}
    //                     >
    //                         {t("fields.filter")}
    //                     </Button>
    //                     {user.codAcceso === 1 && user.CodPerfil !== 4 && (
    //                         <Button
    //                             variant="filled"
    //                             startIcon={IoMdAdd({})}
    //                             onClick={() => {
    //                                 setModalData({});
    //                                 setModalType("add");
    //                                 setIsModalOpen(true);
    //                             }}
    //                             endIcon={undefined}
    //                         >
    //                             {t("waste.addWaste")}
    //                         </Button>
    //                     )}
    //                 </div>
    //             </div>

    //             {loading ? (
    //                 <div className="residuos-grid">
    //                     {[...Array(12)].map((_, i) => (
    //                         <div key={i} className="residuo-card-skeleton" />
    //                     ))}
    //                 </div>
    //             ) : paginatedResiduos.length > 0 ? (
    //                 <>
    //                     <div className="residuos-grid">
    //                         {paginatedResiduos.map((residuo) => (
    //                             <ResiduoCard
    //                                 key={residuo.codResiduo}
    //                                 residuo={residuo}
    //                                 onEdit={handleEdit}
    //                                 onDelete={handleDelete}
    //                             />
    //                         ))}
    //                     </div>

    //                     {totalPages > 1 && (
    //                         <div className="residuos-pagination">
    //                             <Pagination
    //                                 currentPage={currentPage}
    //                                 totalPages={totalPages}
    //                                 itemsPerPage={itemsPerPage}
    //                                 totalItems={filteredResiduos.length}
    //                                 onPageChange={setCurrentPage}
    //                             />
    //                         </div>
    //                     )}
    //                 </>
    //             ) : (
    //                 <div className="residuos-empty">
    //                     <p>{t("waste.noWasteFound")}</p>
    //                 </div>
    //             )}
    //         </div>

    //         <Modal
    //             isOpen={isModalOpen}
    //             onClose={() => setIsModalOpen(false)}
    //             position="side"
    //             actions={
    //                 <>
    //                     <Button
    //                         variant="outlined"
    //                         onClick={() => setIsModalOpen(false)}
    //                         endIcon={undefined}
    //                         startIcon={undefined}
    //                     >
    //                         {t("common.cancel")}
    //                     </Button>
    //                     <Button
    //                         variant="filled"
    //                         onClick={handleSave}
    //                         endIcon={undefined}
    //                         startIcon={undefined}
    //                     >
    //                         {t("common.save")}
    //                     </Button>
    //                 </>
    //             }
    //         >
    //             <h2 className="modal-title">
    //                 {modalType === "edit"
    //                     ? t("waste.editWaste")
    //                     : t("waste.addWaste")}
    //             </h2>
    //             <FormModal
    //                 dynamicFormElements={formElements}
    //                 modalData={modalData}
    //                 associatedOptions={{}}
    //                 handleInputChange={(name, value) => {
    //                     setModalData((prev) => ({ ...prev, [name]: value }));
    //                 }}
    //             />
    //         </Modal>

    //         {isFilterModalOpen && (
    //             <Modal
    //                 position="side"
    //                 isOpen
    //                 onClose={() => setIsFilterModalOpen(false)}
    //                 actions={
    //                     <>
    //                         <Button
    //                             variant="outlined"
    //                             onClick={() => {
    //                                 setFilterValues({});
    //                                 setIsFilterModalOpen(false);
    //                             }}
    //                             endIcon={undefined}
    //                             startIcon={undefined}
    //                         >
    //                             {t("common.clear")}
    //                         </Button>
    //                         <Button
    //                             variant="filled"
    //                             onClick={() => setIsFilterModalOpen(false)}
    //                             endIcon={undefined}
    //                             startIcon={undefined}
    //                         >
    //                             {t("common.apply")}
    //                         </Button>
    //                     </>
    //                 }
    //             >
    //                 <FiltersDrawer
    //                     filterFields={filterFields}
    //                     data={residuos}
    //                     filterValues={filterValues}
    //                     onChange={(key, val) =>
    //                         setFilterValues((prev) => ({ ...prev, [key]: val }))
    //                     }
    //                     onClear={() => setFilterValues({})}
    //                 />
    //             </Modal>
    //         )}

    //         {confirmationModalOpen && (
    //             <Modal
    //                 isOpen={confirmationModalOpen}
    //                 onClose={() => setConfirmationModalOpen(false)}
    //                 position="center"
    //                 actions={
    //                     <>
    //                         <Button
    //                             variant="outlined"
    //                             onClick={() => setConfirmationModalOpen(false)}
    //                             endIcon={undefined}
    //                             startIcon={undefined}
    //                         >
    //                             Cancelar
    //                         </Button>
    //                         <Button
    //                             variant="filled"
    //                             onClick={confirmDelete}
    //                             endIcon={undefined}
    //                             startIcon={undefined}
    //                         >
    //                             Confirmar
    //                         </Button>
    //                     </>
    //                 }
    //             >
    //                 <h2 className="modal-title">
    //                     {t("waste.confirmDeleteTitle")}
    //                 </h2>
    //                 <p className="modal-description">
    //                     {t("waste.confirmDeleteMessage", {
    //                         name: residuoToDelete?.nombre,
    //                     })}
    //                 </p>
    //             </Modal>
    //         )}

    //         <Notification ref={notificationRef} />
    //     </PageLayout>
    // );

    return (
        <PageLayout title={t("waste.title")} subtitle={t("waste.subtitle")}>
            <Table
                columns={[
                    { key: "codResiduo", label: "ID", visible: false },
                    // {
                    //     key: "codigo",
                    //     label: t("waste.columns.code"),
                    //     visible: true,
                    //     sortable: true,
                    // },
                    {
                        key: "nombre",
                        label: t("waste.columns.name"),
                        visible: true,
                        sortable: true,
                        visibleOnExpand: true,
                    },
                    {
                        key: "descripcion",
                        label: t("waste.columns.description"),
                        visible: true,
                        sortable: true,
                        visibleOnExpand: true,
                    },
                    {
                        key: "tipoResiduo/descripcion",
                        label: t("waste.columns.type"),
                        visible: true,
                        sortable: true,
                        visibleOnExpand: true,
                    },
                ]}
                dataTable={residuos}
                showCheckboxes={true}
                noResultsMessage={t("waste.noWasteFound")}
                actions={[t("common.delete"), t("common.edit")]}
                searchTerms={["codigo", "nombre", "tipo"]}
                elementName={t("waste.title")}
                keyProp="codResiduo"
                sortProp="codigo"
                loading={loading}
                expandable={true}
                expandableBreakpoint={600}
                filterFields={filterFields}
                formElements={formElements}
                addApiUrl="/api/Residuos/SetResiduo"
                editApiUrl="/api/Residuos/EditResiduo"
                deleteApiUrl="/api/Residuos/DeleteResiduo"
                userCodAcceso={Number(user.codAcceso)}
                userCodPerfil={Number(user.role)}
            />
        </PageLayout>
    );
}
